import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  // mode: 'history',
  routes: [{
    path: '',
    name: 'home',
    component: () =>
      import ('@/views/Home.vue')
  },
    {
      path: '/add-to-cart',
      name: 'addToCart',
      component: () =>
        import ('@/views/AddToCart.vue')
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: () =>
        import ('@/views/Impressum.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () =>
        import ('@/views/Privacy.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () =>
        import ('@/views/Contact.vue')
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: () =>
        import ('@/views/RegistrationSuccess.vue')
    },
    {
      path: '/hello',
      name: 'hello',
      component: () =>
        import ('@/views/Hello.vue')
    },
    {
      path: '/eula',
      name: 'eula',
      component: () =>
        import ('@/views/Eula.vue')
    },
    {
      path: '/dataprivacy',
      name: 'dataprivacy',
      component: () =>
        import ('@/views/Dataprivacy.vue')
    },
  ]
})
export default router